export const VehicleFuelType = {
    List: [
        {value: "01", label: "VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_GAS"},
        {value: "02", label: "VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_DIESEL"},
        {value: "03", label: "VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_NATURAL_GAS"},
        {value: "04", label: "VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_ELECTRIC"},
        {value: "99", label: "VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_OTHER"},
    ],
    Map: new Map<string, string>([
        ['01', 'VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_GAS'],
        ['02', 'VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_DIESEL'],
        ['03', 'VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_NATURAL_GAS'],
        ['04', 'VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_ELECTRIC'],
        ['99', 'VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_OTHER'],
    ]),
    Enum: {
        Gas: '01',
        Diesel: "02",
        NaturalGas: '03',
        Electric: '04',
        Other: '99'
    }
};